module.exports = __webpack_public_path__ + "img/vids.2aa64b0e.png";